import axios from 'axios'
import { BLOQUEAR_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idEmpresa) => dispach =>
  axios.get(`${URL}/empresas/${idEmpresa}/bloquear`,SLOW_REQUEST_CONFIG)
    .then( reponse => dispach({
      type: BLOQUEAR_EMPRESA,
      payload: reponse
    }));
